import { render, staticRenderFns } from "./overlay-info.vue?vue&type=template&id=6ba37c5c&"
import script from "./overlay-info.vue?vue&type=script&lang=js&"
export * from "./overlay-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports